import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect } from 'react';
export default (function () {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isBrowser = _useState2[0],
    setIsBrowser = _useState2[1];
  useEffect(function () {
    setIsBrowser(true);
  }, []);
  return isBrowser;
});
//# sourceMappingURL=useIsBrowserReady.js.map